import { error_message } from "@constants/Errors";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold">{error_message.generic.not_found}</h1>
      <p className="text-lg mt-4">{error_message.generic.page_not_found}</p>
    </div>
  );
};

export default NotFound;
